import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { AuthUI } from '@/components/AuthUI';
import { AuthChangeEvent, Session } from '@supabase/supabase-js';
import { toast } from 'sonner';

const Auth = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check for existing session on mount
    const checkExistingSession = async () => {
      const { data: { session }, error } = await supabase.auth.getSession();
      if (error) {
        console.error('Session check error:', error);
        toast.error('Error checking authentication status');
        return;
      }
      if (session) {
        console.log('Existing session found, redirecting to app');
        navigate('/app');
      }
    };

    checkExistingSession();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event: AuthChangeEvent, session: Session | null) => {
      console.log('Auth state changed in Auth page:', event, session);
      if (event === 'SIGNED_IN' && session) {
        navigate('/app');
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-sage-50/30 flex items-center justify-center">
      <div className="w-full max-w-md">
        <div className="glass-card rounded-xl p-8 shadow-xl">
          <AuthUI />
        </div>
      </div>
    </div>
  );
};

export default Auth;